/**
 * Same-page visibility for the tire experience banner on the product list / product search results view.
 */

/**
 * Shows the banner when the server-rendered module is eligible, or once it has been shown on this page.
 *
 * @param {JQuery} $root
 * @param {boolean} hasBeenDisplayed
 * @returns {boolean} whether the banner is now displayed
 */
function syncTireExperienceBannerVisibility($root, hasBeenDisplayed) {
	if ($root.length === 0 || $root.attr('data-store-sells-tires') !== '1') {
		return hasBeenDisplayed;
	}

	const shouldShow = hasBeenDisplayed || $root.attr('data-tire-experience-banner-eligible') === '1';

	$root.find('.tire-experience-banner').toggleClass('tire-experience-banner--hidden', !shouldShow);

	return shouldShow;
}

module.exports = {
	syncTireExperienceBannerVisibility,
};
